import { GalleryEntity } from '@entities/Gallery/Types';

export const GetImageFromGalleries = (
    defaultImg: string,
    galleries?: GalleryEntity[]
): string => {
    const imageUrl = galleries?.[0]?.medias?.at(-1)?.url;
    return imageUrl || defaultImg;
};
